import React, { useState, useEffect } from 'react';

const Investigacao = () => {
	return <div className='text-3xl '> INVESTIGACAO DE VIOLENCIA</div>;
};

export default Investigacao;
